'use client';

import 'BomdisoftComponents/bomdisoft-backlink/styles.css';
import { bomdisoftProductLabel, getLanguageFromLocale } from '@bomdisoft/translations';
import { useParams } from 'next/navigation';

export type BomdisoftBacklinkProps = {
  href: string;
  testId?: string;
};

export const BomdisoftBacklink = ({ href, testId = 'footer-bomdisoft-backlink' }: BomdisoftBacklinkProps) => {
  const params = useParams();
  const language = getLanguageFromLocale(typeof params?.lang === 'string' ? params.lang : 'en');

  return (
    <a className='bomdisoft-backlink' data-testid={testId} href={href}>
      {bomdisoftProductLabel[language]}
    </a>
  );
};
